'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectShouldShowNewMap = exports.selectIsMapToggleable = exports.selectMapView = exports.selectFilteringDisabled = exports.selectActiveUrl = exports.selectSearchId = exports.selectReloadCursor = exports.selectCurrentPage = exports.selectVisibleVenues = exports.toggleMapView = exports.setShouldShowNewMap = exports.setMapView = exports.setVisibleVenues = exports.setFiltersFromHash = exports.setFilteringDisabled = exports.setActiveUrl = exports.setSearchId = exports.setReloadCursor = exports.setCurrentPage = exports.TOGGLE_MAP_VIEW = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.reducer = reducer;

var _device = require('redux/modules/device');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_VISIBLE_VENUES = 'classpass/search/SET_VISIBLE_VENUES';
var SET_CURRENT_PAGE = 'classpass/search/SET_CURRENT_PAGE';
var SET_RELOAD_CURSOR = 'classpass/search/SET_RELOAD_CURSOR';
var SET_SEARCH_ID = 'classpass/search/SET_SEARCH_ID';
var SET_ACTIVE_URL = 'classpass/search/SET_ACTIVE_URL';
var SET_FILTERING_DISABLED = 'classpass/search/SET_FILTERING_DISABLED';
var SET_MAP_VIEW = 'classpass/search/SET_MAP_VIEW';
var SET_FILTERS_FROM_HASH = 'classpass/search/SET_FILTERS_FROM_HASH';
var SET_SHOULD_SHOW_NEW_MAP = 'classpass/search/SET_SHOW_NEW_MAPBOX_MAP';
var TOGGLE_MAP_VIEW = exports.TOGGLE_MAP_VIEW = 'classpass/search/TOGGLE_MAP_VIEW';

var setCurrentPage = exports.setCurrentPage = function setCurrentPage(value) {
  return { type: SET_CURRENT_PAGE, key: 'currentPage', value: value };
};
var setReloadCursor = exports.setReloadCursor = function setReloadCursor(value) {
  return { type: SET_RELOAD_CURSOR, key: 'reloadCursor', value: value };
};
var setSearchId = exports.setSearchId = function setSearchId(value) {
  return { type: SET_SEARCH_ID, key: 'searchId', value: value };
};
var setActiveUrl = exports.setActiveUrl = function setActiveUrl(value) {
  return { type: SET_ACTIVE_URL, key: 'activeUrl', value: value };
};
var setFilteringDisabled = exports.setFilteringDisabled = function setFilteringDisabled(value) {
  return { type: SET_FILTERING_DISABLED, key: 'filteringDisabled', value: value };
};
var setFiltersFromHash = exports.setFiltersFromHash = function setFiltersFromHash(filters) {
  return { type: SET_FILTERS_FROM_HASH, filters: filters };
};
var setVisibleVenues = exports.setVisibleVenues = function setVisibleVenues(value) {
  return { type: SET_VISIBLE_VENUES, key: 'visibleVenues', value: value };
};
var setMapView = exports.setMapView = function setMapView(value) {
  return { type: SET_MAP_VIEW, key: 'isMapView', value: value };
};
var setShouldShowNewMap = exports.setShouldShowNewMap = function setShouldShowNewMap(value) {
  return { type: SET_SHOULD_SHOW_NEW_MAP, key: 'shouldShowNewMap', value: value };
};
var toggleMapView = exports.toggleMapView = function toggleMapView() {
  return { type: TOGGLE_MAP_VIEW };
};

var selectSearchState = function selectSearchState(state) {
  return state.features.search;
};
var selectVisibleVenues = exports.selectVisibleVenues = function selectVisibleVenues(state) {
  return selectSearchState(state).visibleVenues;
};
var selectCurrentPage = exports.selectCurrentPage = function selectCurrentPage(state) {
  return selectSearchState(state).currentPage;
};
var selectReloadCursor = exports.selectReloadCursor = function selectReloadCursor(state) {
  return selectSearchState(state).reloadCursor;
};
var selectSearchId = exports.selectSearchId = function selectSearchId(state) {
  return selectSearchState(state).searchId;
};
var selectActiveUrl = exports.selectActiveUrl = function selectActiveUrl(state) {
  return selectSearchState(state).activeUrl;
};
var selectFilteringDisabled = exports.selectFilteringDisabled = function selectFilteringDisabled(state) {
  return selectSearchState(state).filteringDisabled;
};
var selectMapView = exports.selectMapView = function selectMapView(state) {
  return selectSearchState(state).isMapView;
};
var selectIsMapToggleable = exports.selectIsMapToggleable = function selectIsMapToggleable(state) {
  return !(0, _device.selectMediaState)(state).lg;
};
var selectShouldShowNewMap = exports.selectShouldShowNewMap = function selectShouldShowNewMap(state) {
  return selectSearchState(state).shouldShowNewMap;
};

var initialState = {
  currentPage: 1,
  reloadCursor: '',
  searchId: null,
  activeUrl: '',
  filteringDisabled: false,
  isMapView: false,
  shouldShowNewMap: false,
  visibleVenues: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_VISIBLE_VENUES:
    case SET_CURRENT_PAGE:
    case SET_RELOAD_CURSOR:
    case SET_SEARCH_ID:
    case SET_ACTIVE_URL:
    case SET_FILTERING_DISABLED:
    case SET_MAP_VIEW:
    case SET_SHOULD_SHOW_NEW_MAP:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.key, action.value));
    case TOGGLE_MAP_VIEW:
      return (0, _extends4.default)({}, state, {
        isMapView: !state.isMapView
      });
    default:
      return state;
  }
}